import api from "../Axios";
export const apiGetModels = (params) => api.get(`/models/`, { params });
export const apiGetModelsDetail = (id) => api.get(`/models/${id}`);
export const apiUploadModel = (id) => api.post(`/models/${id}/packages`);
export const apiStatModel = (package_id) =>
  api.get(`/models/stat/${package_id}`); // 模型字段统计，图表数据
export const apiGetInstalledModels = (params) =>
  api.get(`/packages`, { params }); // 获取已安装的模型列表
